import script from "./pointsSettle.vue?vue&type=script&setup=true&lang=js"
export * from "./pointsSettle.vue?vue&type=script&setup=true&lang=js"

import "./pointsSettle.vue?vue&type=style&index=0&id=0930156d&lang=scss"

const __exports__ = script;

export default __exports__